import { createRouter, createWebHashHistory } from "vue-router"
import memberParentRouter from './memberParentRouter'
import systemParentRouter from "./systemParentRouter"
import staffParentRouter from "./staffParentRouter"
import pairParentRouter from "./pairParentRouter"

export const mainRoutes = {
  name: "Main",
  component: () => import(/* webpackChunkName: "main" */ "@/views/Main"),
  children: [
    // 首頁
    // {
    //   path: "/index",
    //   component: () => import(/* webpackChunkName: "home" */ "@/views/Home"),
    //   name: "index",
    //   meta: { keepAlive: false },
    // },
    // 系統管理
    ...systemParentRouter,
    // 會員管理
    ...memberParentRouter,
    // 交易對管理
    ...pairParentRouter,
    // 管理員管理
    ...staffParentRouter
  ],
  meta: {
    requiresAuth: true
  },
}

export const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "@/views/Login.vue"),
  },
  mainRoutes,
]

export const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

// Middleware
router.beforeEach((to, from, next) => {
  const isAuthenticated = sessionStorage.getItem("token")
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({ name: "login" })
    } else {
      next()
    }
  } else {
    if(to.path === '/') {
      next({ name: "login" })
    } else {
      next()
    }
  }
})
